import { useContext } from "react";
import { useSelector } from "react-redux";
import { RetrieveWorkLoadsFilter, WorkLoadsCalendar } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  isDirty: boolean;
  workLoads: WorkLoadsCalendar;
  retrieveWorkLoads(request: Boundaries["retrieveWorkLoads"]["request"]): void;
}

function useRetrieveWorkLoads(filter: RetrieveWorkLoadsFilter): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveWorkLoadsRequestPending(filter),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveWorkLoadsRequestSuccess(filter),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveWorkLoadsRequestFailure(filter),
    ),
    isDirty: useSelector(() => selector.isWorkLoadsCalendarDirty(filter)),
    workLoads: useSelector(() => selector.getWorkLoadsCalendar(filter)),
    retrieveWorkLoads: core.retrieveWorkLoads,
  };
}

export { useRetrieveWorkLoads };
